import HorizontalMenu from "../components/horizontalMenu";
// import TemplatesRow from "../components/TemplatesRow";
import axiosInstance from "../utils/axiosInstance";
import TemplatesRow from "../components/Templates/TemplatesRow";

import React, { useState, useEffect } from 'react';

function TemplatePage() {

    const [templatesArray, setTemplatesArray] = useState([]);

  
     useEffect(() => {
        axiosInstance
        .get("/templates")
        .then((response) => {setTemplatesArray(response.data)})
        .catch((error) => {});
    
      }, []);


  return (
    <div>
        <TemplatesRow title="" templates={templatesArray}/>          
    </div>
  );
}

export default TemplatePage;
